import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Helper function to format date/time
const formatDateTime = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleString("en-GB", {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export default function ProjectTable({
    loading,
    data,
    currentPage,
    perPage,
    selectedRows,
    toggleAll,
    toggleRow,
}) {
    const startIdx = (currentPage - 1) * perPage;
    const allSelected = data.every((_, i) => selectedRows[startIdx + i]);

    return (
        <div className="table-responsive border">
            <table className="table align-middle mb-0">
                <thead className="bg-light">
                    <tr>
                        <th className="border">Project ID</th>
                        <th className="border">Title</th>
                        <th className="border">Seller Name</th>
                        <th className="border">Timeline</th>
                        <th className="border">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={3} className="text-center py-3">
                                Loading...
                            </td>
                        </tr>
                    ) : data.length > 0 ? (
                        data.map((item, index) => {
                            const globalIndex = startIdx + index;
                            return (
                                <tr key={globalIndex}>
                                    <td className="fw-semibold border text-primary">
                                        <Link
                                            to={`/buyer-dashboard/communication/${item._id}`}
                                            className="text-black underline"
                                        >
                                            {item.groupId}
                                        </Link>
                                    </td>
                                    <td className="border ">
                                        {item.name}
                                    </td>
                                    <td className="border ">
                                        {item.companyName}
                                    </td>
                                    <td className="fw-semibold border text-primary" style={{ padding: "0.5rem 1rem" }}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>
                                                    <strong>Status:</strong> {item.status || '-'}<br/>
                                                    <strong>Updated:</strong> {formatDateTime(item.updatedAt)}<br/>
                                                    <strong>Progress:</strong> {item.progress || 0}%
                                                </Tooltip>
                                            }
                                        >
                                            <div
                                                className="bg-light rounded-pill"
                                                style={{ height: 6, width: "100%", cursor: "pointer" }}
                                            >
                                                <div
                                                    className={`bg-${item.progressColor || 'primary'} rounded-pill`}
                                                    style={{
                                                        width: `${item.progress || 0}%`,
                                                        height: "100%",
                                                    }}
                                                />
                                            </div>
                                        </OverlayTrigger>
                                    </td>
                                    <td className="fw-semibold border text-primary">
                                        <div
                                            className="btn fw-semibold"
                                            style={{
                                                backgroundColor: "#F8F5FF",
                                                color: "#5014D0",
                                                borderRadius: "20px",
                                                padding: "4px 12px",
                                                fontSize: "0.85rem",
                                            }}
                                        >
                                            {item.status || "-"}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan={3} className="text-center text-muted py-3">
                                No projects found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}
